export default __webpack_public_path__ + "static/media/Foto28.99b7b31f.png";